import Reveal from './Reveal';
import { aboutImage } from '../mock';

const About = () => {
  return (
    <section
      id="hakkimizda"
      className="relative py-32 lg:py-40 px-6 lg:px-10"
    >
      <div className="max-w-[1300px] mx-auto grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        {/* Text */}
        <Reveal variant="left">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-primary" />
            <span className="text-[11px] tracking-[0.28em] text-accent font-medium">
              HAKKIMIZDA
            </span>
          </div>
          <h2 className="text-[40px] sm:text-[48px] lg:text-[56px] leading-[1.05] font-semibold text-white">
            Mimarinin Sinirlarini
            <br />
            Zorluyoruz
          </h2>

          <div className="mt-8 space-y-5 text-[15px] leading-[1.75] text-white/60 max-w-xl">
            <p>
              15 yillik tecrubemizle Asma Germe Celik Konstruksiyon, golgelendirme
              ve mimari cadir sistemleri projelerinde oncu bir firma olmaktan
              gurur duyuyoruz.
            </p>
            <p>
              Kurulusumuzdan bu yana, yenilikci tasarimlarimiz ve ustun
              muhendislik cozumlerimizle sektorde fark yaratmaya devam
              ediyoruz. Turkiye&apos;de ve dunyada bircok prestijli projeye imza
              attik.
            </p>
            <p>
              Deneyimli ekibimiz, modern ekipmanlarimiz ve yenilikci
              yaklasimimizla, her projeyi zamaninda ve butce dahilinde
              tamamlamayi basardik.
            </p>
          </div>
        </Reveal>

        {/* Image */}
        <Reveal variant="right" delay={150}>
          <div className="relative">
          <div className="relative overflow-hidden rounded-2xl aspect-[4/5] shadow-2xl group">
            <img
              src={aboutImage}
              alt="Membran yapi detayi"
              className="w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -left-6 w-24 h-24 border-l-2 border-b-2 border-primary rounded-bl-2xl pointer-events-none" />
          <div className="absolute -top-6 -right-6 w-24 h-24 border-r-2 border-t-2 border-clay/60 rounded-tr-2xl pointer-events-none" />
        </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
